import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesNoOptionalOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface ExpenseCodesSegmentedControlProps {
  name: string;
  id: string;
  label: string;
}

export function ExpenseCodesSegmentedControl({
  name,
  id,
  label,
}: ExpenseCodesSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      width="100%"
      id={id}
      control={control}
      label={label}
      name={name}
      defaultValue="No"
      options={getYesNoOptionalOptions(id)}
    />
  );
}
